import { render, staticRenderFns } from "./OrderProcess.vue?vue&type=template&id=12c0bc2d&scoped=true"
import script from "./OrderProcess.vue?vue&type=script&lang=js"
export * from "./OrderProcess.vue?vue&type=script&lang=js"
import style0 from "./OrderProcess.vue?vue&type=style&index=0&id=12c0bc2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0bc2d",
  null
  
)

export default component.exports